export function fmtDate(value: string | null | undefined): string {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function fmtDateTime(value: string | null | undefined): string {
  if (!value) return "—";
  return new Date(value).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function fmtPct(value: number | null | undefined, digits = 1): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return `${value.toFixed(digits)}%`;
}

export function cls(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

export const PROVIDER_LABELS: Record<string, string> = {
  gmail: "Gmail",
  google_workspace: "Google Workspace",
  outlook: "Outlook",
  microsoft_365: "Microsoft 365",
  hotmail: "Hotmail",
  yahoo: "Yahoo",
  aol: "AOL",
  icloud: "iCloud",
  zoho: "Zoho",
  proton: "Proton",
  other_imap: "Other IMAP",
};

export const SENDING_PROVIDER_LABELS: Record<string, string> = {
  gmail: "Gmail",
  google_workspace: "Google Workspace",
  outlook: "Outlook",
  microsoft_365: "Microsoft 365",
  smtp_com: "SMTP.com",
  sendgrid: "SendGrid",
  amazon_ses: "Amazon SES",
  mailgun: "Mailgun",
  postmark: "Postmark",
  sparkpost: "SparkPost",
  brevo: "Brevo",
  custom_smtp: "Custom SMTP",
  kumomta: "KumoMTA",
  powermta: "PowerMTA",
  other_smtp: "Other SMTP",
};

export const TEMPLATE_CATEGORY_LABELS: Record<string, string> = {
  plain_text: "Plain Text",
  sales: "Sales Email",
  marketing: "Marketing",
  newsletter: "Newsletter",
  transactional: "Transactional",
  cold_outreach: "Cold Outreach",
  promotional: "Promotional",
  follow_up: "Follow-up",
  custom: "Custom",
};

export const STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  queued: "Queued",
  sending: "Sending",
  waiting_for_delivery: "Waiting for delivery",
  analyzing: "Analyzing",
  completed: "Completed",
  partial: "Partial",
  failed: "Failed",
  cancelled: "Cancelled",
  active: "Active",
  paused: "Paused",
  disabled: "Disabled",
  inactive: "Inactive",
};

export const PLACEMENT_LABELS: Record<string, string> = {
  inbox: "Inbox",
  category: "Category",
  promotions: "Promotions",
  spam: "Spam",
  junk: "Junk",
  missing: "Missing",
  other: "Other",
};

export function initials(name: string): string {
  return name
    .split(" ")
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}
